import {
  type HubJob,
  type HubJobKind,
  HubJobStatus,
} from '@robovision/hub'
import { colorCache } from '@robovision/rvai-utils'
import { JobRuntimeParameters } from '../algorithm/jobDefinitions/common/JobRuntimeParameters'


export interface JobParams {
  algorithmId: string
  algorithmVersion: string
  completedAt?: Date
  createdAt: Date
  creatorId: string
  external: boolean
  id: string
  jobDefinitionId: string
  kind: HubJobKind
  logs?: Record<string, unknown>
  name: string
  projectId: string
  result?: Record<string, unknown>
  runtimeParameters: JobRuntimeParameters
  status: HubJobStatus
  statusMessage?: string
}

// TODO JOB rename
export class JobV2 {
  static readonly modelName = 'Job'

  public readonly algorithmId: string
  public readonly algorithmVersion: string
  public readonly color: string
  public readonly completedAt?: Date
  public readonly createdAt: Date
  public readonly creatorId: string
  public readonly external: boolean
  public readonly id: string
  public readonly jobDefinitionId: string
  public readonly kind: HubJobKind
  public readonly logs?: Record<string, unknown>
  public readonly name: string
  public readonly projectId: string
  public readonly result?: Record<string, unknown>
  public readonly runtimeParameters: JobRuntimeParameters
  public readonly status: HubJobStatus
  public readonly statusMessage?: string

  public constructor (params: JobParams) {
    this.algorithmId = params.algorithmId
    this.algorithmVersion = params.algorithmVersion
    // TODO custom jobs will use the same color space
    // which is not ideal
    this.color = colorCache.getColor(params.projectId, params.id)
    this.completedAt = params.completedAt
    this.createdAt = params.createdAt
    this.creatorId = params.creatorId
    this.external = params.external
    this.id = params.id
    this.jobDefinitionId = params.jobDefinitionId
    this.kind = params.kind
    this.logs = params.logs
    this.name = params.name
    this.projectId = params.projectId
    this.result = params.result
    this.runtimeParameters = params.runtimeParameters
    this.status = params.status
    this.statusMessage = params.statusMessage
  }

  // public get hasModel () {
  //   return this.resourceId !== undefined
  // }

  // // Training is done and model is available
  // // Also FAILED trainings can have models!
  // public get isModelReady () {
  //   return !this.isInProgress && this.hasModel
  // }

  public get isFinished () {
    return this.status === HubJobStatus.DONE ||
      this.status === HubJobStatus.FAILED ||
      this.status === HubJobStatus.STOPPED
  }

  // public get isSuccess () {
  //   return this.status === HubJobStatus.DONE ||
  //   (this.status === HubJobStatus.STOPPED && this.resourceId !== undefined)
  // }

  public get isStopping () {
    return this.status === HubJobStatus.STOPPING
  }

  public get isStopped () {
    return this.status === HubJobStatus.STOPPED
  }

  public get isFailed () {
    return this.status === HubJobStatus.FAILED
  }

  public get isRunning () {
    return this.status === HubJobStatus.RUNNING
  }

  public get isQueued () {
    return this.status === HubJobStatus.QUEUED
  }

  public get isInProgress () {
    return (
      this.status === HubJobStatus.RUNNING ||
      this.status === HubJobStatus.QUEUED ||
      this.status === HubJobStatus.STARTING
    )
  }

  /**
   * @deprecated use `id` instead
   */
  public get jobId () {
    return this.id
  }

  public static fromResponse (response: HubJob): JobV2 {
    return new JobV2({
      algorithmId: response.algorithmId,
      algorithmVersion: response.algorithmVersion,
      completedAt: response.completedAt ? new Date(response.completedAt) : undefined,
      createdAt: new Date(response.createdAt),
      creatorId: response.creatorId,
      external: response.external,
      id: response.id,
      jobDefinitionId: response.definitionId,
      kind: response.kind,
      logs: response.logs,
      name: response.name,
      projectId: response.projectId,
      result: response.result,
      runtimeParameters: JobRuntimeParameters.fromRuntimeParameters(response.runtimeParameters),
      status: response.status,
      statusMessage: response.statusMessage,
    })
  }
}
